import React from 'react';
import moment from 'moment';
import { maskCapitalizeFirstLetter } from '../../../masks';

const ClientServiceTimeNav = props => {
  const { subject: client, className } = props;
  if (
    !('client_service_preferences' in client) ||
    client.client_service_preferences.length === 0
  )
    return '';
  const pref = client.client_service_preferences[0];
  const time = moment(pref.start_time, ['HH:mm']).format('h:mm A');

  return (
    <div className={className}>
      {maskCapitalizeFirstLetter(pref.day_of_week)} at {time}
    </div>
  );
};

export default ClientServiceTimeNav;



// WEBPACK FOOTER //
// ./src/components/onboarding/client/ClientServiceTimeNav.js